import Breadcrumb from "../../Component/Breadcrumb";

function Exams() {
  return (
    <>
      <Breadcrumb>Academics / Examination and Promotion</Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Examination and Promotion</h1>
            </div>

            <div className="col-lg-12">
              <img src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/coming-soon.png" className="coming_soon" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Exams;
